import { ChevronLeft } from 'lucide-react';
import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { ConversationDetails } from '@/Domain/components/Inbox/ConversationDetails/ConversationDetails';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { Sheet, SheetContent } from '@/Domain/components/Shared/Sheet/sheet';
import { Spinner } from '@/Domain/components/Shared/Spinner';

type Props = {
  listContent: ReactNode;
  hasSelectedConversation: boolean;
  listUrl: string;
  isFetched: boolean;
};

export const MobileInboxLayout = ({
  listContent,
  hasSelectedConversation,
  listUrl,
  isFetched,
}: Props) => {
  const { t } = useTranslation(['inbox_v2', 'common']);
  const navigate = useNavigate();
  const [detailsOpen, setDetailsOpen] = useState(false);

  if (!hasSelectedConversation) {
    return (
      <div className="flex h-[calc(100vh-53px)] w-full flex-col bg-card p-4">{listContent}</div>
    );
  }

  return (
    <div className="flex h-[calc(100vh-53px)] w-full flex-col bg-background">
      <div className="flex shrink-0 items-center justify-between border-b border-border bg-card px-2 py-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(listUrl)}
          aria-label={t('common:back')}
        >
          <ChevronLeft className="h-5 w-5" />
          {t('common:back')}
        </Button>
        <Button variant="secondary" size="sm" onClick={() => setDetailsOpen(true)}>
          {t('inbox_v2:details_button')}
        </Button>
      </div>
      <div className="flex w-full flex-1 overflow-y-auto hide-scrollbar">
        {!isFetched ? (
          <div className="flex flex-1 items-center justify-center">
            <Spinner className="h-7 w-7" />
          </div>
        ) : (
          <Outlet />
        )}
      </div>
      <Sheet open={detailsOpen} onOpenChange={setDetailsOpen}>
        <SheetContent side="right" className="w-[85vw] overflow-y-auto bg-card p-0 sm:w-[400px]">
          <ConversationDetails
            isCollapsed={false}
            onCollapsedChange={() => setDetailsOpen(false)}
          />
        </SheetContent>
      </Sheet>
    </div>
  );
};
